// extracted by mini-css-extract-plugin
export var cardIcon = "_7a-5";
export var checkboxCard = "_7a-0";
export var checkboxCardSelected = "_7a-4";
export var disabled = "_7a-2";
export var interactive = "_7a-1";
export var outerBorder = "_7a-3";
export var spacerMedium = "_7a-8";
export var spacerSmall = "_7a-7";
export var spacerXsmall = "_7a-6";